import accounting from "accounting";
import { Chart } from "./chart";

export const BarChart = Chart.extend({
    chartType: "Bar",
    constructor: function constructor() {
        Chart.apply(this, arguments);
        this.extendChartOptions({
            legend: {
                enabled: false
            },
            chart: {
                margin: [0, 0, 0, 0],
                spacingTop: 0,
                spacingBottom: 0,
                spacingLeft: 0,
                spacingRight: 0,
                backgroundColor: "rgba(255, 255, 255, 0)"
            },
            xAxis: {
                maxPadding: 0,
                pointPadding: 0,
                tickLength: 0,
                title: {
                    text: null
                }
            },
            yAxis: {
                tickInterval: 20, // This value has a bunch of corresponding css styles for the ticks. don't change
                min: 0,
                max: 100,
                gridLineWidth: 0
            },
            plotOptions: {
                bar: {
                    enable: true,
                    pointWidth: 14,
                    groupPadding: 0.1,
                    borderWidth: 0,
                    dataLabels: {
                        allowOverlap: true,
                        overflow: "justify",
                        align: "right",
                        crop: false,
                        y: 0,
                        x: `${this.y}`.length * (`${this.y}`.length - 1), // Need to base on the length of value as the x is from the right side of the label box not the left
                        inside: true,
                        borderWidth: 0,
                        borderRadius: "5px",
                        backgroundColor: "rgba(255,255,255,0.5)",
                        padding: 5,
                        verticalAlign: "middle",
                        useHTML: true,
                        style: {
                            color: "#000000",
                            backgroundColor: "rgba(255,255,255,0.5)",
                            textAlign: "left",
                            fontSize: "1.2rem",
                            textShadow: "0 0 1px contrast, 0 0 1px contrast"
                        },
                        formatter() {
                            const minRateValue = 0.01;
                            let val = this.y;
                            
                            if (val > 0 && val < minRateValue) {
                                val = `&lt; ${minRateValue}`;
                            } else {
                                val = accounting.toFixed(val, 2);
                            }
                            
                            return `<div style="font-size:8px">${val}%</div>`;
                        }
                    }
                }
            },
            tooltip: {
                headerFormat: "",
                valueSuffix: "%",
                borderColor: null
            }
        });
    }
});
